import { useCookies } from 'react-cookie';
import { useCallback } from 'react';
import { getSessionCookieName } from '#config';

export const useSessionCookie = () => {
  const cookieName = getSessionCookieName();
  const [cookies,, removeCookie] = useCookies([cookieName]);

  const removeSessionCookie = useCallback(() => {
    removeCookie(cookieName, { path: '/' });
  }, [cookieName, removeCookie]);

  return {
    sessionCookie: cookies[cookieName],
    removeSessionCookie,
  };
};
